/**
 * HTML5 ad banners are iframes with a fixed design size (e.g. width="420"
 * height="340"). Shrinking such an iframe with CSS (max-width: 100%;
 * height: auto) collapses it to the browser default of 150px high and the
 * banner ends up in a small scrollable box. Instead, keep the iframe at its
 * design size and scale it down as a whole to the width of its ad block;
 * the wrapper gets the scaled height so nothing below overlaps.
 */
const adIframes = (selector = '.single-add-block iframe[width][height]') => {
	const iframes = [...document.querySelectorAll(selector)];
	if (!iframes.length) return;

	const fit = (iframe) => {
		const width = parseFloat(iframe.getAttribute('width'));
		const height = parseFloat(iframe.getAttribute('height'));
		const wrapper = iframe.parentElement;
		if (!width || !height || !wrapper) return;

		const available = wrapper.closest('.single-add-block')?.clientWidth || wrapper.clientWidth;
		const scale = Math.min(1, available / width);

		// Inline so it wins over every `max-width: 100%; height: auto` rule.
		Object.assign(iframe.style, { display: 'block', maxWidth: 'none', border: '0', transformOrigin: 'top left' });
		iframe.style.width = `${width}px`;
		iframe.style.height = `${height}px`;
		iframe.style.transform = scale < 1 ? `scale(${scale})` : '';
		wrapper.style.height = `${Math.ceil(height * scale)}px`;
		wrapper.style.overflow = 'hidden';
	};

	iframes.forEach(fit);

	if ('ResizeObserver' in window) {
		const observer = new ResizeObserver(() => iframes.forEach(fit));
		iframes.forEach((iframe) => {
			const block = iframe.closest('.single-add-block');
			if (block) observer.observe(block);
		});
	} else {
		window.addEventListener('resize', () => iframes.forEach(fit), { passive: true });
	}
};

export default adIframes;
